import { mutatorAction } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import getStore from '../store';
import { getTodayIdentifier, saveNeedsReplyDismissState } from '../utils/localStorageHelper';

const setWasDismissedMutator: (mailboxInfo: MailboxInfo) => void = mutatorAction(
    'setReplyNudgeWasDismissed',
    (mailboxInfo: MailboxInfo): void => {
        const store = getStore();
        store.wasDismissed = true;
        saveNeedsReplyDismissState(mailboxInfo, getTodayIdentifier());
    }
);

export default setWasDismissedMutator;
